const GIFT_WRAP_VARIANT_ID = 53915047395667;

async function removeGiftWrapIfAlone() {
  const cart = await fetch('/cart.js').then(r => r.json());

  if (cart.items.length !== 1) return false;

  const item = cart.items[0];

  if (Number(item.variant_id) !== GIFT_WRAP_VARIANT_ID) return false;

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      id: item.key,
      quantity: 0,
    }),
  });

  updateCartItemCounts(0);
  return true;
}

window.removeGiftWrapIfAlone = removeGiftWrapIfAlone;
async function openCartDrawer() {
  const removedGiftWrap = await removeGiftWrapIfAlone();

  if (removedGiftWrap) {
    await updateCartDrawer();
  }

  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");  

  let chatClose = document.getElementById('shopify-chat');    
  if (chatClose) chatClose.style.visibility = 'hidden';

  const teaser = document.querySelector('[data-testid="animated-teaser"]');
  if (teaser) teaser.style.display = 'none';  
}

window.openCartDrawer = openCartDrawer;

function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
    let chatClose = document.getElementById('shopify-chat');    
  if (chatClose) chatClose.style.visibility = 'visible';

  const teaser = document.querySelector('[data-testid="animated-teaser"]');
  if (teaser) teaser.style.display = '';
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
  });
}
window.updateCartItemCounts = updateCartItemCounts;

async function updateCartDrawer() {
  // 1) Save current state
  const oldMsgEl = document.getElementById("discount-message");
  const oldLabelEl = document.getElementById("discount-section__label");
  const oldInputEl = document.getElementById("discount-code");

  const savedMessage = oldMsgEl?.textContent || "";
  const savedMsgColor = oldMsgEl?.style.color || "";
  const savedLabelColor = oldLabelEl?.style.color || "";
  const savedInputValue = oldInputEl?.value || "";
  const savedInputBorder = oldInputEl?.style.border || "";

  // 2) Fetch & replace drawer HTML
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".cart-drawer").innerHTML;
  document.querySelector(".cart-drawer").innerHTML = newBox;

  // 3) Restore saved state
  const newMsgEl = document.getElementById("discount-message");
  const newLabelEl = document.getElementById("discount-section__label");
  const newInputEl = document.getElementById("discount-code");

  if (newMsgEl) newMsgEl.textContent = savedMessage;
  if (newMsgEl) newMsgEl.style.color = savedMsgColor;

  if (newLabelEl) newLabelEl.style.color = savedLabelColor;
  if (newInputEl) newInputEl.value = savedInputValue;
  if (newInputEl) newInputEl.style.border = savedInputBorder;

  // 4) Re-attach listeners
  addCartDrawerListeners();
  discountCodeApplying();
  initGiftWrapListener();
  //— Gift funkcija
  window.updateCartCount();
  await removeGiftWrapIfAlone();
}

window.updateCartDrawer = updateCartDrawer;

function addCartDrawerListeners() {
  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        const rootItem = button.closest(".cart-lineitem");
        const key = rootItem.getAttribute("data-line-item-key");

        const currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains(
          "cart-drawer-quantity-selector-plus"
        );
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);
        updateCartDrawer();
      });
    });

  document
    .querySelectorAll(".cart-drawer-quantity-selector input[type='number']")
    .forEach((input) => {
      input.addEventListener("change", async (e) => {
        let newQuantity = parseInt(e.target.value, 10);
        if (isNaN(newQuantity) || newQuantity < 1) newQuantity = 1;
        e.target.value = newQuantity;

        const rootItem = input.closest(".cart-lineitem");
        const key = rootItem.getAttribute("data-line-item-key");

        const res = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);
        await updateCartDrawer();
      });
    });

  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  document
    .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
    .forEach((el) => {
      el.addEventListener("click", () => {
        closeCartDrawer();
      });
    });
}

addCartDrawerListeners();
discountCodeApplying();
document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    await fetch("/cart/add", {
      method: "post",
      body: new FormData(form),
    });

    const res = await fetch("/cart.js");
    const cart = await res.json();
    updateCartItemCounts(cart.item_count);

    await updateCartDrawer();
    openCartDrawer();
    await removeGiftWrapIfAlone();
     });
});

document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});

function discountCodeApplying() {
  const discountCodeApplyBtn = document.getElementById("apply-discount");
  if (!discountCodeApplyBtn) return;

  const wrongCodeText = discountCodeApplyBtn.dataset.wrong;
  const successCodeText = discountCodeApplyBtn.dataset.success;
  const emptyCodeText = discountCodeApplyBtn.dataset.empty;

  const discountMessage = document.getElementById("discount-message");
  const spinner = document.getElementById("spinner");
  const invalidCodes = new Set();

  const discountSectionLabel = document.getElementById(
    "discount-section__label"
  );
  const discountCodeInput = document.getElementById("discount-code");

  if (discountCodeInput && discountMessage) {
    discountCodeInput.addEventListener("focus", () => {
      discountMessage.textContent = "";
      discountMessage.style.color = "var(--neutral-1000)";
      discountSectionLabel.style.color = "var(--neutral-1000)";
      discountCodeInput.style.border = "1px solid var(--neutral-1000)";
    });
  }

  discountCodeApplyBtn.addEventListener("click", async () => {
    const discountCodeInput = document.getElementById("discount-code");
    const discountCode = discountCodeInput.value.trim();

    discountMessage.textContent = "";

    if (discountCode === "") {
      discountMessage.textContent = emptyCodeText;
      return;
    }

    spinner.style.display = "block";
    try {
      const cartRes = await fetch("/cart.js");
      const cart = await cartRes.json();

      let existingCodes = (cart.discount_codes || [])
        .map((dc) => dc.code)
        .filter((code) => code && !invalidCodes.has(code));

      const updatedCodes = [...existingCodes, discountCode];
      const updateRes = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ discount: updatedCodes.join(",") }),
      });
      const updateData = await updateRes.json();
      const newCodeEntry = updateData.discount_codes?.find(
        (dc) => dc.code === discountCode
      );

      if (!newCodeEntry?.applicable) {
        discountMessage.textContent = wrongCodeText;
        discountMessage.style.color = "#A92626";
        discountSectionLabel.style.color = "#A92626";
        discountCodeInput.style.border = "1px solid #A92626";
        invalidCodes.add(discountCode);
      } else {
        discountMessage.textContent = successCodeText;
        discountMessage.style.color = "#939E95";
        discountSectionLabel.style.color = "#939E95";
        discountCodeInput.style.border = "1px solid #939E95";
      }

      const updatedCart = await (await fetch("/cart.js")).json();
      updateCartItemCounts(updatedCart.item_count);
      await updateCartDrawer();
    } catch (err) {
      console.error("Discount error:", err);
      discountMessage.textContent = wrongCodeText;
      discountMessage.style.color = "#A92626";
      discountSectionLabel.style.color = "#A92626";
      discountCodeInput.style.border = "1px solid #A92626";
    } finally {
      spinner.style.display = "none";
    }
  });
}

/* ------------------------------ */
/* GIFT WRAP — NEW FUNCTION       */
/* ------------------------------ */

function initGiftWrapListener() {
  const checkbox = document.getElementById('giftwrap-checkbox');
  if (!checkbox) return;

  checkbox.addEventListener('change', async function () {
    const variantId = Number(this.dataset.variant);
    if (!variantId) return;

    try {
      if (this.checked) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
          }),
        });
      } else {
        const cart = await fetch('/cart.js').then(r => r.json());
        const item = cart.items.find(i => i.variant_id === variantId);

        if (item) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              id: item.key,
              quantity: 0,
            }),
          });
        }
      }

      const cart = await fetch('/cart.js').then(r => r.json());
      updateCartItemCounts(cart.item_count);

      await updateCartDrawer();
      openCartDrawer();

    } catch (err) {
      console.error('Gift wrap error:', err);
    }
  });
}


